export const vehicleTypes = {
	car: 'Car',
	bus: 'Bus',
	taxi: 'Taxi',
}
